import { createStructuredSelector } from 'reselect';
import {
  selectSelectedCharityName,
  selectStartDate,
  selectNoOfPayments,
  selectGrantAmount,
  selectEditMode,
} from './RecommendGrantPageSelectors';
import { selectFrequency } from './ConfirmationPageSelectors';

export const recGrantScheduleDerivedStates = createStructuredSelector({
  grantName: selectSelectedCharityName,
  startDate: selectStartDate,
  frequency: selectFrequency,
  noOfPayment: selectNoOfPayments,
  grantAmount: selectGrantAmount,
  editMode: selectEditMode,
});
